import React, { useEffect, useState } from "react";
import Button from "../../../components/form/Button";
import Input from "../../../components/form/Input";
import useForm from "../../../hooks/useForm";
import { toast } from "react-toastify";
import { formValidate } from "../../../helpers/formValidate";
import ImageUploader from "../../../components/form/ImageUploader";
import { useDispatch } from "react-redux";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { setTitle } from "../../../helpers/MetaTag";
import {
  profileUpdate,
  profileDetails,
} from "../../../services/ProfileService";
import ChangePassword from "../change-password/changePassword";
import { setProfile } from "../../../redux/slice/profileSlice,";
import { Validation } from "../../../helpers/Validation";
import { useSelector } from "react-redux";
import PhoneNumberFormat from "../../../components/form/PhoneNumberFormat";

const EditProfile = () => {
  setTitle("ORG Chart Admin | Profile");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const profile = useSelector((state) => state?.profile?.data);
  const [phone, setPhone] = useState("");

  const validation = {
    firstName: { required: true, message: "Please enter your first name!" },
    lastName: { required: true, message: "Please enter your last name!" },
  };

  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({}, validation);

  useEffect(() => {
    if (profile) {
      setFieldsValue({
        firstName: profile?.firstName || "",
        lastName: profile?.lastName || "",
        email: profile?.email || "",
      });
      if (profile?.image?.url) {
        setImage(profile?.image?.url);
      }
      setPhone(profile?.phone || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  const onSubmit = (values) => {
    setLoading(true);
    if (!Validation("email", values.email)) {
      toast.error("Invalid email format. Please enter a valid email.");
      setLoading(false);
      return;
    }
      if (phone?.length > 12) {
          toast.error("Phone number cannot exceed 12 characters.");
          setLoading(false);
          return; 
        }

    profileUpdate({
      firstName: values?.firstName,
      lastName: values?.lastName,
      email: values?.email,
      phone: phone || "",
      image: image || "null",
    }).then((res) => {
      if (res?.status === 200) {
        toast.success(res?.message);
        dispatch(setProfile(res?.data));
      }
      setLoading(false);
    });
  };

  return (
    <div className="border bg-white dark:bg-slate-700 border-gray-200 p-4 shadow rounded-md">
      <div className="flex justify-between items-center mb-3">
        <div className="text-2xl font-bold text-slate-900 dark:text-slate-400">Profile</div>
      </div>
      <form onSubmit={(e) => handleSubmit(e, onSubmit)}>
        <div className="grid grid-cols-12 gap-4">
          <div className="image bg-white dark:bg-slate-700 p-4 col-span-12 lg:col-span-3 border-r border-slate-200 dark:border-slate-500 h-auto">
            <ImageUploader
              label=""
              labelClasses="text-lg font-bold"
              isMultiple={false}
              image={image}
              setImage={setImage}
              inputClasses="h-48 w-48"
              buttonLabel={image ? "Change image" : "Upload image"}
            />
          </div>
          <div className="input bg-white dark:bg-slate-700 col-span-12 lg:col-span-9 ">
            <div className="text-xl font-bold mb-3 text-slate-900 dark:text-slate-400">Profile Info</div>
            <div className="grid lg:grid-cols-2 gap-3">
              <div className="relative">
                <Input
                  label={"FirstName"}
                  inputType={"text"}
                  value={values?.firstName}
                  inputPlaceholder={"Enter first name"}
                  inputName="firstName"
                  onChange={handleChange}
                  isValidate={true}
                  {...formValidate(errors, "firstName")}
                />
              </div>
              <div className="relative">
                <Input
                  label={"LastName"}
                  inputType={"text"}
                  value={values?.lastName}
                  inputPlaceholder={"Enter last name"}
                  inputName="lastName"
                  onChange={handleChange}
                  isValidate={true}
                  {...formValidate(errors, "lastName")}
                />
              </div>
              <div className="relative">
                <Input
                  label={"Email"}
                  inputType={"text"}
                  value={values?.email}
                  inputPlaceholder={"Enter email"}
                  inputName="email"
                  onChange={handleChange}
                  isValidate={true}
                  isDisabled={true}
                  {...formValidate(errors, "email")}
                />
              </div>
              <div className="relative">
                <PhoneNumberFormat
                  label="Phone"
                  value={phone}
                  isInputGroup={true}
                  inputGroupIcon={"fa-solid fa-phone"}
                  inputGroupPosition={"left"}
                  setPhone={setPhone}
                  inputPlaceholder={"(xxx) xxx-xxxx"}
                  charLimit={12}
                />
              </div>
            </div>
            <div className="w-full flex items-center justify-end gap-3 mt-4">
              <div
                className="flex justify-end items-center"
                data-tooltip-id="edit-profile"
                data-tooltip-place="left"
              >
                <Button
                  buttonType={"submit"}
                  buttonIcon={"fa-light fa-floppy-disk"}
                  buttonIconPosition={"left"}
                  buttonLabel="Save"
                  loading={loading}
                />
                <Tooltip
                  id="edit-profile"
                  className="!text-slate-500 dark:!text-slate-200 !text-sm !bg-slate-950 dark:!bg-slate-400 !bg-opacity-100 z-100"
                  render={() => (
                    <div className="text-white">
                      Click to save profile details.
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
      <ChangePassword />
    </div>
  );
};

export default EditProfile;
